import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { EntregaPorBairroReponse, EntregaPorBairroRequest } from 'src/app/shared/models/bairro.model';
import { first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntregaService {
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService
  ) { }

  private get base() {
    return `${this.authService.baseUrl}/produtos/integracao/taxaEntrega`;
  }

  public getIntegracaoEntrega() {
    return this.http.get<ApiResponse<EntregaPorBairroReponse>>(`${this.base}`).pipe(
      first(),
    );
  }

  public getEntregaGlobal() {
    return this.http.get<ApiResponse<EntregaPorBairroReponse>>(`${this.base}/geral`).pipe(
      first(),
    )
  }

  public postIntegracaoEntrega(model: EntregaPorBairroRequest) {
    return this.http.post<ApiResponse<EntregaPorBairroRequest>>(`${this.base}`, model).pipe(
      first(),
    )
  }

  public updateIntegracaoEntrega(model: EntregaPorBairroRequest) {
    return this.http.put<ApiResponse<EntregaPorBairroRequest>>(`${this.base}`, model).pipe(
      first(),
    )
  }

  public deleteIntegracaoEntrega(nome: string) {    
    return this.http.delete<ApiResponse<string>>(`${this.base}/${nome}`).pipe(
      first(),
    )
  }
}
